const SidebarWidget = () => {
  return (
    <div
      className="
        mx-auto mb-13 w-full max-w-60 rounded-2xl
        bg-gray-50 px-4 py-5 text-center
        dark:bg-white/[0.03]
      "
    >
      <p className="mb-4 text-gray-500 text-theme-sm dark:text-gray-400">
        Have questions, feedback, or ideas to improve GetEat? We'd love to hear
        from you.
      </p>

      <a
        href="mailto:support@geteat.net"
        className="flex items-center justify-center rounded-lg bg-brand-500 p-3 font-medium text-white text-theme-sm hover:bg-brand-600"
      >
        support@geteat.net
      </a>
    </div>
  );
};

export default SidebarWidget;
